import React from 'react'
import Icons from './Icons'
import Crypto from './Crypto'
import NotFound from 'components/NotFound'

export default function ({ view }) {
  switch (view) {
    case 'crypto':
      return <Crypto />
    case 'icons':
      return <Icons />
    default:
      return <NotFound />
  }
}
